// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"624":"clere","738":"course-manager"}[chunkId] || chunkId) + "." + {"368":"05e5115e","575":"96795700","624":"9f89ef8a","738":"6f57e41e"}[chunkId] + ".css";
};